<div [formGroup]="formGroup">
  <tui-input-phone
    [countryCode]="removeCountryCodeFromValue ? '' : countryCode"
    [formControlName]="formControlName"
    [nativeId]="id"
    [phoneMaskAfterCountryCode]="phoneMaskAfterCountryCode"
    [pseudoFocus]="focus ?? null"
    [pseudoInvalid]="invalid === undefined ? null : invalid"
    [readOnly]="properties?.readOnly ?? false"
    [tuiHintContent]="hintContent"
    [tuiTextfieldCleaner]="true"
    [tuiTextfieldIconLeft]="icon"
    [tuiTextfieldPrefix]="removeCountryCodeFromValue ? countryCode : ''"
    [tuiTextfieldSize]="size"
    (focusedChange)="handleFocusedChange($event)"
  >
    {{ label }}
    <span
      class="tui-required"
      *ngIf="validators.required"
    ></span>
    <input
      tuiTextfield
      type="tel"
      inputmode="tel"
      [attr.placeholder]="placeholder ?? ''"
      [attr.required]="validators.required"
    />
  </tui-input-phone>
</div>
